module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7GAFou/tc-custom/9781625852380.jpg?1702409741358",
      "alt": "This image is the cover for the book Christimas in Birmingham"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Christimas in Birmingham\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("For decades, the Christmas season in Birmingham was not complete without the sights and sounds of the retail district. During the season, the Magic City made magic with elaborate light displays and the Living Christmas Tree in Woodrow Wilson Park. Many remember the battling Santas of Loveman's and Pizitz, each vying for the hearts of the community. The elaborate Enchanted Forest dazzled shoppers on the sixth floor at Pizitz. In the 1940s, more than 200,000 people lined the streets each year to make merry for the Christmas Carnival parade. Author and local historian Tim Hollis celebrates the happy history of Birmingham's holiday season, reviving the traditions and festivities, the food and shopping of days gone by.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tim Hollis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tim Hollis has been a pop culture historian nearly all his life. He owns a museum of toys, advertising, holiday memorabilia and other baby-boomer relics that he makes available to visitors and researchers by appointment. Having lived in Birmingham his entire life, he supplies the nostalgic materials for the popular www.BirminghamRewound.com website, through which he may also be contacted.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0